import * as React from 'react'

export const SVG_ImageCapture = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52">
        <g fill="none" fillRule="evenodd">
            <g fill="#42B6E7" fillRule="nonzero">
                <g>
                    <g>
                        <g>
                            <path
                                d="M28.869 5.634h-4.016l-.793-3.936C23.86.714 22.983 0 21.972 0H10.09C9.079 0 8.2.714 8.003 1.698L7.21 5.634H3.194C1.433 5.634 0 7.055 0 8.803v18.31c0 1.747 1.433 3.168 3.194 3.168h25.675c1.76 0 3.194-1.421 3.194-3.169V8.802c0-1.747-1.433-3.168-3.194-3.168zM10.09 2.113h11.88l.71 3.52h-13.3l.71-3.52zm19.842 25c0 .582-.477 1.056-1.064 1.056H3.194c-.587 0-1.065-.474-1.065-1.057V8.802c0-.582.478-1.056 1.065-1.056h25.675c.587 0 1.064.474 1.064 1.057v18.31z"
                                transform="translate(-11 -10) translate(11 10) translate(9.5 10) translate(.469 .469)"
                            />
                            <path
                                d="M16.031 10.42c4.077 0 7.392 3.316 7.392 7.393 0 4.076-3.315 7.392-7.392 7.392-4.076 0-7.392-3.316-7.392-7.392 0-4.077 3.316-7.393 7.392-7.393zm0 2.316c-2.799 0-5.076 2.278-5.076 5.076 0 2.8 2.277 5.077 5.076 5.077 2.8 0 5.077-2.278 5.077-5.076 0-2.8-2.278-5.077-5.077-5.077zM8.221 10.688H6.03c-.379 0-.685.398-.685.89s.306.89.685.89H8.22c.379 0 .685-.398.685-.89s-.306-.89-.685-.89z"
                                transform="translate(-11 -10) translate(11 10) translate(9.5 10) translate(.469 .469)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)
